import { computed, type ComputedRef } from 'vue'
import { useStore } from 'vuex'
import { useUserStore } from '@/stores/user-store'
import { effectiveWorkspace, type Workspace } from '@/constants/workspaces'

/**
 * A área que a navbar, a sidebar e o seletor devem exibir.
 *
 * Os três liam `store.state.currentWorkspace` direto e cada um tratava a falta
 * de permissão do seu jeito, então discordavam entre si quando o valor salvo
 * era 'ai-agents' e a pessoa não tinha mais o papel. Aqui a conta é uma só.
 *
 * Ver effectiveWorkspace em @/constants/workspaces para o porquê de a decisão
 * ser na leitura e não na gravação.
 */
export function useEffectiveWorkspace(): ComputedRef<Workspace> {
  const vuexStore = useStore()
  const userStore = useUserStore()

  return computed(() =>
    effectiveWorkspace((vuexStore.state as { currentWorkspace?: unknown }).currentWorkspace, {
      aiAgents: userStore.aiAgentsAtLeast('viewer'),
    }),
  )
}
